import React from 'react';
import AiChatFab from './AiChatFab';
import AiChatPanel from './AiChatPanel';
import './AiChatStyle.css';

/**
 * App-mounted Materiah AI shell: collapsed round FAB or open panel.
 * Parent should gate on lab auth (`token && !isSupplier`) and config flag.
 *
 * @returns {JSX.Element}
 */
const AiChatShell = () => {
  const [open, setOpen] = React.useState(false);

  if (open) {
    return <AiChatPanel onClose={() => setOpen(false)} />;
  }

  return <AiChatFab onClick={() => setOpen(true)} />;
};

export default AiChatShell;
